"use strict";function _inheritsLoose(subClass, superClass) {subClass.prototype = Object.create(superClass.prototype);subClass.prototype.constructor = subClass;_setPrototypeOf(subClass, superClass);}function _setPrototypeOf(o, p) {_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {o.__proto__ = p;return o;};return _setPrototypeOf(o, p);} /* eslint-disable no-undef,new-cap */
var flagIconTemplate = require('../ebay-icon/icons/ebay-report-flag-icon/index.marko');
var playIconTemplate = require('../ebay-icon/icons/ebay-video-play-icon/index.marko');

// Marko 4 workaround
var flagIcon = flagIconTemplate.default || flagIconTemplate;
var playIcon = playIconTemplate.default || playIconTemplate;

// Have to contain in order to not execute until shaka is downloaded
function getElements(self) {
  var Report = /*#__PURE__*/function (_shaka$ui$Element) {_inheritsLoose(Report, _shaka$ui$Element);
    function Report(parent, controls, text) {var _this;
      _this = _shaka$ui$Element.call(this, parent, controls) || this;

      // The actual button that will be displayed
      _this.button_ = document.createElement('button');
      _this.button_.classList.add('video-player__report-button');

      _this.button_.textContent = text || 'Report';
      flagIcon.renderSync().prependTo(_this.button_);
      _this.parent.appendChild(_this.button_);

      _this.eventManager.listen(_this.button_, 'click', function () {
        self.emit('report');
      });return _this;
    }return Report;}(shaka.ui.Element);

  Report.Factory = /*#__PURE__*/function () {
    function _class(reportText) {
      this.reportText = reportText;
    }var _proto = _class.prototype;_proto.

    create = function create(rootElement, controls) {
      return new Report(rootElement, controls, this.reportText);
    };return _class;}();


  var TextSelection = shaka.ui.TextSelection;

  TextSelection.Factory = /*#__PURE__*/function () {function _class2() {}var _proto2 = _class2.prototype;
    /** @override */_proto2.
    create = function create(rootElement, controls) {
      return new shaka.ui.TextSelection(rootElement, controls);
    };return _class2;}();


  return { Report, TextSelection };
}

module.exports = { getElements, playIcon };